import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { SCHEDULED_MESSAGES_BASE_QUERY_KEY } from './scheduledMessagesQuery';

type SendScheduledMessageMutationArgs = {
  scheduledMessageUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, SendScheduledMessageMutationArgs>,
  'mutationFn' | 'mutationKey'
>;

const sendScheduledMessage = ({
  scheduledMessageUid,
  ...payload
}: SendScheduledMessageMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/triggers/scheduled-messages/send/${scheduledMessageUid}`,
    payload,
  );
};

const useSendScheduledMessageMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: sendScheduledMessage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SCHEDULED_MESSAGES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useSendScheduledMessageMutation;
